import { STATION_LOGO, imageSrc } from '@/lib/images'

interface WatermarkedImageProps {
  src?: string | null
  alt: string
  className?: string
  imgClassName?: string
}

function WatermarkedImage({ src, alt, className = '', imgClassName = 'h-full w-full object-cover' }: WatermarkedImageProps) {
  return (
    <div className={`relative overflow-hidden ${className}`}>
      <img src={imageSrc(src)} alt={alt} className={imgClassName} />
      <img
        src={STATION_LOGO}
        alt=""
        className="pointer-events-none absolute bottom-2 right-2 h-7 w-auto drop-shadow-[0_1px_4px_rgba(0,0,0,0.55)] sm:h-9"
      />
    </div>
  )
}

export default WatermarkedImage
